import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { RouterProvider } from '@tanstack/react-router'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { onSessionEnded, watchSession } from '@/auth/oidc'
import '@/i18n'
import { createAppRouter } from './router'
import './index.css'

const queryClient = new QueryClient({
  defaultOptions: { queries: { staleTime: 15_000, refetchOnWindowFocus: true } },
})
const router = createAppRouter(queryClient)

// Sitzung nicht mehr erneuerbar (Refresh fehlgeschlagen oder 401): Daten verwerfen, zur Anmeldung.
watchSession()
onSessionEnded(() => {
  queryClient.clear()
  void router.navigate({ to: '/login', search: { expired: 1 } })
})

async function bootstrap() {
  // Mocks nur auf Wunsch (VITE_USE_MOCKS=1) und nie im Produktions-Bundle
  if (import.meta.env.DEV && import.meta.env.VITE_USE_MOCKS === '1') {
    const { startMocks } = await import('./mocks/worker')
    await startMocks()
  }
  render()
}

function render() {
  createRoot(document.getElementById('root') as HTMLElement).render(
    <StrictMode>
      <QueryClientProvider client={queryClient}>
        <RouterProvider router={router} />
      </QueryClientProvider>
    </StrictMode>,
  )
}

void bootstrap()
